export const CertCard = ({ title, description, imgUrl }) => {
    return (
        <div className="proj-imgbx">
            <img src={imgUrl} alt={title}/>
            <div className="proj-txtx">
                <h4>{title}</h4>
                <span>{description}</span>
            </div>
        </div>
    )
}